const designs = [
    {
        id: 1,
        title: "JobWize",
        shortDescription: "A dynamic job application tracker designed to streamline career journey management",
        longDescription: [
            "A dynamic job application tracker designed to streamline career journey management."],
        cardImage: "assets/designs/jobwize/jobwize.png",
        headerImage: "assets/designs/jobwize/jobwize-header.png",
        images: [
            "assets/designs/jobwize/jobwize.png",
            "assets/designs/jobwize/jobwize-login.png",
            "assets/designs/jobwize/jobwize-dashboard.png",
            "assets/designs/jobwize/jobwize-applications.png",
            "assets/designs/jobwize/jobwize-profile.png",
            "assets/designs/jobwize/jobwize-analytics.png",
        ],
        prototype: "",
        tags: ["Figma", "Mobile Design",],
    },
    {
        id: 2,
        title: "Pellucid Web",
        shortDescription: "Designed & developed the company website for Pellucid IT",
        longDescription: [
            "Designed and developed the company website for Pellucid IT."],
        cardImage: "assets/designs/pellucid/pellucid.png",
        headerImage: "assets/designs/pellucid/pellucid-header.png",
        images: [
            "assets/designs/pellucid/pellucid-header.png",
            "assets/designs/pellucid/pellucid-services-home.png",
            "assets/designs/pellucid/pellucid-proposition.png",
            "assets/designs/pellucid/pellucid-es.png",
            "assets/designs/pellucid/pellucid-portfolio.png",
            "assets/designs/pellucid/pellucid-contact-us.png",
        ],
        prototype: "",
        tags: ["Canva", "Photoshop", "Web Design"],
    }, {
        id: 3,
        title: "FST Handbooks",
        shortDescription: "Handbooks for the Faculty of Science & Technology",
        longDescription: [
            "This project involved the creation of three distinct and visually appealing covers for the Faculty of Science & Technology (FST) at the University of the West Indies, Cave Hill Campus."
        ],
        cardImage: "assets/designs/fst-handbooks/fst-handbooks.png",
        headerImage: "assets/designs/fst-handbooks/fst-handbooks-header.png",
        images: [
            "assets/designs/fst-handbooks/fst-handbooks.png",
            "assets/designs/fst-handbooks/fst-handbooks-postgraduate.png",
            "assets/designs/fst-handbooks/fst-handbooks-rig.png",
            "assets/designs/fst-handbooks/fst-handbooks-undergraduate.png",
        ],
        prototype: "",
        tags: ["Canva", "Graphic Design", "Handbooks"],
    }, {
        id: 4,
        title: "Recall Rumble",
        shortDescription: "Engaging memory matching game designed to test your recall abilities!",
        longDescription: [
            "Recall Rumble is an engaging memory matching game designed to test your recall abilities! Challenge yourself and see how well you can match your cards."],
        cardImage: "assets/designs/recall-rumble/recall-rumble.png",
        headerImage: "assets/designs/recall-rumble/recall-rumble-header.png",
        images: [
            "assets/designs/recall-rumble/recall-rumble.png",
            "assets/designs/recall-rumble/recall-rumble-web.png",
            "assets/designs/recall-rumble/recall-rumble-mobile.png",
            "assets/designs/recall-rumble/recall-rumble-qr.png",
        ],
        prototype: "",
        tags: ["Canva", "Procreate"],
    }, {
        id: 5,
        title: "Querencia Studios",
        shortDescription: "Branding, marketing materials and video editing for Querencia Studios",
        longDescription: [
            "Branding, marketing materials and video editing for Querencia Studios."],
        cardImage: "assets/designs/querencia-studios/querencia-studios.png",
        headerImage: "assets/designs/querencia-studios/querencia-studios-header.png",
        images: [
            "assets/designs/querencia-studios/querencia-studios.png",
            "assets/designs/querencia-studios/querencia-business-card-front.png",
            "assets/designs/querencia-studios/querencia-studios-pricelist.png",
            "assets/designs/querencia-studios/querencia-studios-price-increase-memo.png",
            "assets/designs/querencia-studios/querencia-studios-qr-code.png",
        ],
        prototype: "",
        tags: ["Canva", "Photoshop", "Davinci Resolve"],
    }, {
        id: 6,
        title: "CSS - UWI (FST)",
        shortDescription: "Branding and marketing materials for Computer Science Society",
        longDescription: [
            "Branding and marketing materials for Computer Science Society, Faculty of Science and Technology at the University of the West Indies, Cave Hill."],
        cardImage: "assets/designs/css/css.png",
        headerImage: "assets/designs/css/css-header.png",
        images: [
            "assets/designs/css/css-qr-code.png",
            "assets/designs/css/css-agm-poster.png",
            "assets/designs/css/css-interview-prep.png",
            "assets/designs/css/css-turtles.png",
            "assets/designs/css/ieee-qr-code.png",
        ],
        prototype: "",
        tags: ["Canva"],
    }, {
        id: 7,
        title: "The Document Place",
        shortDescription: "Branding and marketing materials for The Document Place",
        longDescription: [
            "Branding and marketing materials for The Document Place."],
        cardImage: "assets/designs/tdp/tdp.png",
        headerImage: "assets/designs/tdp/tdp-header.png",
        images: [
            "assets/designs/tdp/tdp-business-card-back.png",
            "assets/designs/tdp/tdp-business-card.png",
            "assets/designs/tdp/tdp-business-card-ad.png",
            "assets/designs/tdp/tdp-business-card-mockup.png",
            "assets/designs/tdp/tdp-passport-visa-poster.png",
        ],
        prototype: "",
        tags: ["Canva", "Photoshop", "Illustrator"],
    },
    {
        id: 8,
        title: "Academic Link-Edu",
        shortDescription: "Logo creation, branding and marketing materials for Academic Link-Edu",
        longDescription: [
            "Logo creation, branding and marketing materials for Academic Link-Edu."],
        cardImage: "assets/designs/alu/alu.png",
        headerImage: "assets/designs/alu/alu-header.png",
        images: [
            "assets/designs/alu/alu.png",
            "assets/designs/alu/academic-link-edu-logo-vision-board.png",],
        prototype: "",
        tags: ["Canva", "Photoshop"],
    }

];

export default designs;
